import React, {ReactComponentElement, useEffect, useState} from "react";
import {FlyerFrameSettingDto, FlyerPageDto, FlyerPageSpotDto, UserDto} from "../../../../../dtos";
import {
    Box,
    Button,
    Input,
    Typography,
    Select,
    MenuItem,
    SelectChangeEvent,
    Grid,
    Paper,
    InputBase, InputAdornment
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ReactComponent as ChevronLeft} from '../../../../../assets/editors/flyers_left_arrow.svg';
import {ReactComponent as ChevronRight} from '../../../../../assets/editors/flyers_right_arrow.svg';
import validator from "validator";
import {
    dispatchEventDataType,
    EVENT_TYPE_FLYER_RIGHT_PANEL_CONTROL_SELECT_NEXT_OR_PREV_FRAME, EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER
} from "../../../../../globals/EventDispatcher";
import {useTypedSelector} from "../../../../../hooks/useTypeSelector";
import {ReactComponent as AddToMyListIcon} from "../../../../../assets/add_to_my_list_icon.svg";
import {ReactComponent as JumpToPageIcon} from "../../../../../assets/jump_to_page_flyer_icon.svg";
import {ReactComponent as JumpToURLIcon} from "../../../../../assets/jump_to_URL_icon.svg";
import {ReactComponent as PlayVideoIcon} from "../../../../../assets/play_video_icon.svg";
import {ReactComponent as Play360VideoIcon} from "../../../../../assets/play_360_video_icon.svg";
import {ReactComponent as ImageIcon} from "../../../../../assets/open_image_url_icon.svg";
import {ICoordinatesAndSizesForSelectedFrameDto} from "./FlyerPages";
// @ts-ignore
import {ReactTinyLink} from 'react-tiny-link';
import ReactTooltip from "react-tooltip";
import styles from "../../../flyersCatalog/mainFlyersCatalog/flyer/flyer.module.scss";
import axios from "axios";
import {PreviewUrlPopup} from "../../../../com/previewUrlPopup/previewUrlPopup";
import {ReactComponent as ApprovePage} from "../../../../../assets/pages/approved_page.svg";
import {ReactComponent as NotApprovePage} from "../../../../../assets/pages/not_approved_page.svg";
import {ReactComponent as ApprovePageForSystem} from "../../../../../assets/pages/approved_page_system.svg";
import {ReactComponent as EyeIcon} from "../../../../../assets/frames_screen/eye_open_icon.svg";
import {changeQualificationStatusForFrame} from "../../../../../store/actionCreators/spotsActionCreators";
import {useDispatch} from "react-redux";
import {getIconStyle} from "../../../../../globals/globFunctions";
import cameraIcon from "../../../../../assets/camera_icon.svg";


const frameTypes = [
    {
        value: `1`,
        label: 'Open Promo popup with items',
        icon: <AddToMyListIcon style={{width: `100%`, height: `100%`}}/>
    },
    {
        value: `2`,
        label: 'Go to Page',
        icon: <JumpToPageIcon style={{width: `100%`, height: `100%`}}/>
    },
    {
        value: `3`,
        label: 'Open URL',
        icon: <JumpToURLIcon style={{width: `100%`, height: `100%`}}/>
    },
    {
        value: `4`,
        label: 'Play Video',
        icon: <PlayVideoIcon style={{width: `100%`, height: `100%`}}/>
    },
    {
        value: `5`,
        label: 'Show Image',
        icon: <ImageIcon style={{width: `100%`, height: `100%`}}/>
    },
    {
        value: `6`,
        label: 'Play 360',
        icon: <Play360VideoIcon style={{width: `100%`, height: `100%`}}/>
    },
]

const useStyles = makeStyles(() => ({
    framesRightPanel: () => ({
        height: `100%`,
        backgroundColor: `#ffffff`,
        boxShadow: `rgba(0, 0, 0, 0.35) 0px 5px 15px`,
        padding: `16px`,
        '& .MuiTypography-root': {
            letterSpacing: `0.2px`
            // fontSize: `20px`
        }
    }),
    rowBox: {
        flexFlow: `row`,
        display: `flex`,
    },
    columnBox: {
        display: `flex`,
        flexFlow: `column`
    },

    framesRightPanelHeader: {},

    pinControl: {},

    frameRightPanelTitle: {
        '& > .MuiTypography-root': {
            fontWeight: `bold`,
            // fontSize: `20px`
        }
    },
    framesControlsWrapper: (props: any) => ({
        justifyContent: props.isOnlyOneSelectedFrame ? `space-between` : `center`,
        alignItems: `center`,
        height: `60px`,
        '& > .MuiButton-root': {
            width: `32px`,
            height: `32px`,
            padding: `8px`,
            backgroundColor: `#014780`,
            '& > svg': {
                width: `100%`,
                height: `100%`,
                '& > path': {
                    fill: `#ffffff`
                }
            },
            '&:hover': {
                backgroundColor: `#014780B3`,
                // boxShadow: `rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset`,
            },
            '&:disabled': {
                backgroundColor: `#01478033`
            }
        }
    }),
    framesRightPanelContent: {
        flex: `1 1 auto`,
        height: `0`,
        overflow: `auto`,
        padding: `8px 0`
    },

    settingBox: {
        display: `flex`,
        flexDirection: `column`,
        width: `100%`,
        padding: `8px 0`
    },

    titleBox: {
        marginBottom: `5px`,
        display: `flex`,
        justifyContent: `space-between`,
        alignItems: `center`,
        '& > .MuiTypography-root': {
            color: `#5C5C5C`
        }
    },
    inputStyles: () => ({
        width: `100%`,
        lineHeight: `1`,
        // backgroundColor: '#ffffff',
        border: `1px solid #888888`,
        backgroundColor: `white`,
        borderRadius: "5px",
        "&.MuiInputBase-multiline": {
            padding: `0`,
        },
        "&.MuiInput-root": {
            '& > input': {
                // fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                height: "38px",
                padding: `0 5px`,
                lineHeight: `20px`,
                fontSize: "14px",
                color: `#5C5C5C`,
                fontFamily: "Arial",
            },
            '& > textarea': {
                // fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                padding: `5px`,
                // direction: props.direction
                // lineHeight: `1`,
            }
        },
        "&.requiredField": {
            borderLeft: `4px solid #E5870E`,
            borderRadius: `0 5px 5px 0`,
        },
        "&.notValid": {
            borderLeft: `4px solid #E5870E`,
            borderLeftColor: `red`,
        },
        "&.Mui-disabled": {
            backgroundColor: `#dbdbdb`,
        },
    }),

    inputBaseWrapper: {
        '&.MuiPaper-root': {
            p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            width: `100%`,
            height: `40px`,
            boxShadow: `none`,
            padding: `0`,
            border: `1px solid #888888`,
            backgroundColor: `white`,
        },
        '&.notValid': {
            borderLeft: `4px solid #E5870E`,
            borderLeftColor: `red`,
        }
    },

    inputBaseLeftRightText: {
        '&.MuiTypography-root': {
            textAlign: `center`,
            lineHeight: `15px`,
            fontSize: `14px`,
            color: `#A3A3A3`
        }
    },

    baseInput: {
        '&.MuiInputBase-root': {
            height: `100%`,
            border: `none`,
            margin: `0`,
            flex: 1,
            fontSize: "14px",
            padding: `0!important`,
            color: `#5C5C5C`,
            fontFamily: "Roboto",
            borderRadius: `0`,
            '& > .MuiInputBase-input': {
                padding: `0`
            }
        }
    },

    framesRightPanelFooter: {
        '& .MuiButton-root': {
            height: `36px`,
            width: `100%`,
            background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
            textTransform: `none`,
            '&:disabled': {
                opacity: `0.5`,
            }
        }
    },
    qualificationIconWrapper: (props: any) => ({
        display: "flex",
        width: "22px",
        height: "22px!important",
        alignItems: "center",
        justifyContent: "center",
        cursor: props.isNotQualified ? "default" : "pointer",
    })

}));

interface SelectFrameTypeDto {
    value?: string,
    label?: string,
    icon?: ReactComponentElement<any>
}

interface PlaceholdersDto {
    title: string | null,
    link: string | null
}

export interface DataForPreviewDto {
    description: string;
    image: string;
    title: string;
    url: string;
    domain: string;
    frameType: string;
}

interface Props {
    selectedFramesData: FlyerPageSpotDto[];
    pageDto: FlyerPageDto;
    currentFramesState: FlyerFrameSettingDto;
    defaultFramesState: FlyerFrameSettingDto;
    setCurrentState: (framesSetting: FlyerFrameSettingDto) => void;
    coordinatesAndSizesForSelectedFrame: null | ICoordinatesAndSizesForSelectedFrameDto;
}

export const FramesScreenRightPanel: React.FC<Props> = ({
                                                            selectedFramesData,
                                                            pageDto,
                                                            currentFramesState,
                                                            setCurrentState,
                                                            defaultFramesState,
                                                            coordinatesAndSizesForSelectedFrame
                                                        }) => {
    const dispatch = useDispatch();
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const framesStates = useTypedSelector((state) => state.spots);
    let {spots} = useTypedSelector((state) => state);
    const [currentSelectedFrameIndex, setCurrentSelectedFrameIndex] = useState<number>(-1);
    const [qualificationLvlForSelectedFrame, setQualificationLvlForSelectedFrame] = useState<number>(selectedFramesData.length && selectedFramesData[0]?.qualificationLevel ? selectedFramesData[0]?.qualificationLevel : 0);
    const [valueForFramesType, setValueForFramesType] = useState<SelectFrameTypeDto>({});
    const [placeholderForTitle, setPlaceholderForTitle] = useState<string | null>(null);
    const [placeholderForLink, setPlaceholderForLink] = useState<string | null>(null);
    const [placeholderForAppLink, setPlaceholderForAppLink] = useState<string | null>(null);
    const [isDisabledSaveButton, setDisableSaveButton] = useState<boolean>(true);
    const [dataForPreviewLink, setDataForPreviewLink] = useState<DataForPreviewDto>();
    const totalSpotsOnPageNumber = pageDto && pageDto.flyerPageSpots ? pageDto.flyerPageSpots.length : 0;
    const classesProperties = {
        isOnlyOneSelectedFrame: selectedFramesData.length === 1 && selectedFramesData[0]?.fpsCode,
        isNotQualified: selectedFramesData.length === 1 && selectedFramesData[0]?.qualificationLevel === 0,
    }
    const flyerIconStyleType = flyerDetailsState.flyGusRec?.gusIconContrast || 1;
    const mainGuiColorForFlyer = flyerDetailsState.flyGusRec?.gusPrimaryColorRgb || "#ffffff";
    const iconStyleData = getIconStyle(flyerIconStyleType);
    const classes = useStyles(classesProperties);
    let userDtoStr = localStorage.getItem('userDto');
    // const isUserViewer = false;
    let isUserViewer = true;
    let isUserEditor = false;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
        isUserEditor = userDto.role === 2;
    }


    useEffect(() => {
        let frameTypeSelectValue: SelectFrameTypeDto = currentFramesState.fpsFrameType ? frameTypes[currentFramesState.fpsFrameType - 1] : frameTypes[0];
        setValueForFramesType(frameTypeSelectValue);
        const isDefaultStateChanged = compareDefaultAndCurrentState();
        const isNewFrame = !currentFramesState.hasNumber;
        if(isNewFrame){
            setDisableSaveButton(!isValid || !isValidUrlApp);
            return;
        }
        setDisableSaveButton(!isDefaultStateChanged || !isValid || !isValidUrlApp);
    }, [currentFramesState]);

    useEffect(() => {
        const frameType = Number(valueForFramesType.value);
        const placeholders = setPlaceholderForTooltip(frameType);
        const appPlaceholder = setPlaceholderForAppTooltip(frameType);

        setPlaceholderForTitle(placeholders?.title);
        setPlaceholderForLink(placeholders?.link);
        setPlaceholderForAppLink(appPlaceholder);
    }, [valueForFramesType])

    useEffect(() => {
        if (selectedFramesData.length === 1) {
            setCurrentSelectedFrameIndex(selectedFrameIndex());
        } else {
            setCurrentSelectedFrameIndex(-1);
        }
        setQualificationLvlForSelectedFrame(selectedFramesData.length && selectedFramesData[0]?.qualificationLevel ? selectedFramesData[0]?.qualificationLevel : 0);
    }, [selectedFramesData]);

    useEffect(() => {
        const allFramesOnPage = pageDto.flyerPageSpots;
        if (currentSelectedFrameIndex !== -1 && allFramesOnPage && allFramesOnPage.length) {
            const selectedFrameData = allFramesOnPage[currentSelectedFrameIndex];
            dispatchEventDataType(EVENT_TYPE_FLYER_RIGHT_PANEL_CONTROL_SELECT_NEXT_OR_PREV_FRAME, selectedFrameData);
        }
    }, [currentSelectedFrameIndex]);

    useEffect(() => {
        if (framesStates.type === "CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_SUCCESS") {
            setQualificationLvlForSelectedFrame(qualificationLvlForSelectedFrame === 1 ? 2 : 1);
        }
    }, [framesStates.type]);


    const getPreviewData = async () => {
        try {
            const result = await axios.get(`https://api.linkpreview.net/?key=b025846de020fd01f5eed5d164bf87e7&q=${currentFramesState.fpsFrameLink}`);
            setDataForPreviewLink({
                description: result.data.description,
                image: result.data.image,
                title: result.data.title,
                url: result.data.url,
                domain: new URL(result.data.url).host,
                frameType: valueForFramesType.value || "1"
            });
        } catch (err) {
            console.log(err);
            setDataForPreviewLink({
                description: "Can't get information from link",
                image: cameraIcon,
                title: "Error",
                url: currentFramesState.fpsFrameLink || "",
                domain: new URL(currentFramesState.fpsFrameLink || "").host,
                frameType: valueForFramesType.value || "1"
            });
        }
    }

    const setDataForPreviewBasedOnFrameType = () => {
        if(!isValid){
            return;
        }
        switch (valueForFramesType.value){
            case "2": {
                const pageDataFromNumberWhichUserPutInFrameLink = flyerDetailsState.flyerPages.find((page: FlyerPageDto) => page.flpPageNo === Number(currentFramesState.fpsFrameLink))
                if(!pageDataFromNumberWhichUserPutInFrameLink){
                    break;
                }
                setDataForPreviewLink({
                    description: `Jump to Page ${pageDataFromNumberWhichUserPutInFrameLink.flpPageNo}`,
                    image: "",
                    title: `Jump to Page ${pageDataFromNumberWhichUserPutInFrameLink.flpPageNo}`,
                    url: pageDataFromNumberWhichUserPutInFrameLink.flpImageUrl || "None",
                    domain: "",
                    frameType: valueForFramesType.value || "2"
                });
                break;
            }
            case "3":
            case "4": {
                getPreviewData();
                break;
            }
            case "5":
            case "6": {
                setDataForPreviewLink({
                    description: "",
                    image: "",
                    title: "",
                    url: currentFramesState.fpsFrameLink || "",
                    domain: "",
                    frameType: valueForFramesType.value || "2"
                });
                break;
            }
            default: {
                break;
            }
        }
    }

    const compareDefaultAndCurrentState = (): boolean => {
        return JSON.stringify(defaultFramesState) !== JSON.stringify(currentFramesState);
    }

    const setPlaceholderForTooltip = (frameType: number): PlaceholdersDto => {
        let placeholder: null | PlaceholdersDto;
        switch (frameType) {
            case 2:
                placeholder = {
                    title: `Jump to {page number}`,
                    link: `Please Enter the Number of Page`
                };
                break;
            case 3:
                placeholder = {
                    title: `Open Link {URL}`,
                    link: `Please Enter the Site URL`
                };
                break;
            case 4:
                placeholder = {
                    title: `Play Video {URL}`,
                    link: `Please Enter the Video URL`
                };
                break;
            case 5:
                placeholder = {
                    title: `Open Image {URL}`,
                    link: `Please Enter the Image URL`
                };
                break;
            case 6:
                placeholder = {
                    title: `Open 360 Image {URL}`,
                    link: `Please Enter the 360 Image URL`
                };
                break;
            default:
                placeholder = {
                    title: null,
                    link: null
                };
                break;
        }
        return placeholder;
    }

    const setPlaceholderForAppTooltip = (frameType: number): string | null => {
        let placeholder: null | string;
        switch (frameType) {
            case 2:
                placeholder = `Please Enter the Number of Page`;
                break;
            case 3:
                placeholder = `Please Enter the Application Site URL`;
                break;
            case 4:
                placeholder = `Please Enter the Application Video URL`;
                break;
            case 5:
                placeholder = `Please Enter the Application Image URL`;
                break;
            case 6:
                placeholder = `Please Enter the 360 Image Application URL`;
                break;
            default:
                placeholder = null
                break;
        }
        return placeholder;
    }

    const selectedFrameIndex = (): number => {
        const allFramesOnPage = pageDto.flyerPageSpots;
        let currentFrameIndex = -1;
        const currentSelectedFrame = selectedFramesData[0];
        allFramesOnPage?.forEach((frame: FlyerPageSpotDto, index) => {
            if (currentSelectedFrame.fpsRecId === frame.fpsRecId) {
                currentFrameIndex = index;
                return false;
            }
        })
        return currentFrameIndex;
    }

    const onClickNextFrameBtn = (isNextFrame: boolean) => {
        const allFramesOnPage = pageDto.flyerPageSpots;
        let futureFrameIndex = 0;
        const currentSelectedFrame = selectedFramesData[0];
        allFramesOnPage?.forEach((frame: FlyerPageSpotDto, index) => {
            if (currentSelectedFrame.fpsRecId === frame.fpsRecId) {
                if (isNextFrame) {
                    if (index + 1 > (allFramesOnPage.length - 1)) {
                        futureFrameIndex = allFramesOnPage.length - 1;
                    } else {
                        futureFrameIndex = index + 1;
                    }
                } else {
                    if (index - 1 < 0) {
                        futureFrameIndex = 0;
                    } else {
                        futureFrameIndex = index - 1;
                    }
                }
            }
        })
        setCurrentSelectedFrameIndex(futureFrameIndex);
    }

    const onChangeFrameType = (event: SelectChangeEvent) => {
        const frameType = Number(event.target.value);
        setCurrentState({
            ...currentFramesState,
            fpsFrameType: frameType
        });
    }

    const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        const targetName = event.target.name;
        const value = event.target.value;
        if (targetName === 'fpsTocEntry') {
            setCurrentState({
                ...currentFramesState,
                fpsTocEntry: {
                    ...currentFramesState.fpsTocEntry,
                    caption: value
                }
            });
        } else if (targetName === 'fpsIconYPct' || targetName === 'fpsIconXPct') {
            const isAllowedNumber = /[0-9]/.test(value);
            if (value === "" || (Number(value) !== 0 && isAllowedNumber && Number(value) < 96)) {
                setCurrentState({
                    ...currentFramesState,
                    [targetName]: value !== '' ? value : null,
                });
            }
        } else {
            setCurrentState({
                ...currentFramesState,
                [targetName]: value !== '' ? value : null,
            });
        }
    }

    const onSaveFramesSetting = () => {
        if (selectedFramesData.length) {
            dispatchEventDataType(EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER, {
                selectedFrames: selectedFramesData,
                newData: currentFramesState,
                isHorizontalOrientationForFrames: spots.isHorizontalOrientationForFrames
            });

        }

    }

    const onChangeQualificationLVL = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        if (selectedFramesData.length === 1 && selectedFramesData[0].qualificationLevel !== 0) {
            let framesIds = [selectedFramesData[0].fpsRecId!];

            dispatch(changeQualificationStatusForFrame(
                framesIds,
                flyerDetailsState?.flyLacRec?.lacCode!,
                selectedFramesData[0].qualificationLevel === 1 ? 2 : 1,
                flyerDetailsState,
                pageDto.flpPageNo ? pageDto.flpPageNo - 1 : 0,
                pageDto.flyerPageSpots
            ));
        }
    }

    let isValid: boolean;
    let isValidUrlApp: boolean = true;
    switch (currentFramesState.fpsFrameType) {
        case 2:
            const isLegalNumber = Number(currentFramesState.fpsFrameLink) >= 1 && Number(currentFramesState.fpsFrameLink) <= flyerDetailsState?.flyerPages?.length;
            isValid = validator.isNumeric(currentFramesState.fpsFrameLink ? currentFramesState.fpsFrameLink : ``)
                && isLegalNumber
                && Number(currentFramesState.fpsIconXPct) >= 5
                && Number(currentFramesState.fpsIconXPct) <= 95
                && Number(currentFramesState.fpsIconYPct) >= 5
                && Number(currentFramesState.fpsIconYPct) <= 95
            ;
            break;
        case 3:
        case 4:
        case 5:
        case 6:
            isValid = validator.isURL(currentFramesState.fpsFrameLink ? currentFramesState.fpsFrameLink : ``)
                && Number(currentFramesState.fpsIconXPct) >= 5
                && Number(currentFramesState.fpsIconXPct) <= 95
                && Number(currentFramesState.fpsIconYPct) >= 5
                && Number(currentFramesState.fpsIconYPct) <= 95
            ;
            const expression = /^([-a-zA-Z0-9])?[-a-zA-Z0-9@:%._\+~#=]{1,256}?([a-zA-Z0-9])+:[-a-zA-Z0-9@:%._\+~#=]{1,256}/gi;
            const regex = new RegExp(expression);
            const link = currentFramesState.fpsFrameLinkApp;
            if (link && link !== '') {
                if (link.match(regex)) {
                    isValidUrlApp = true;
                } else {
                    isValidUrlApp = false;
                }
            } else {
                isValidUrlApp = true;
            }
            break;
        default:
            isValid = Number(currentFramesState.fpsIconXPct) >= 5
                && Number(currentFramesState.fpsIconXPct) <= 95
                && Number(currentFramesState.fpsIconYPct) >= 5
                && Number(currentFramesState.fpsIconYPct) <= 95
            ;
            isValidUrlApp = true;
            break;
    }

    const frameTypeSelectOptions = frameTypes.map((frameType: SelectFrameTypeDto) => {
        let Icon;
        switch (frameType.value) {
            case "2": {
                Icon = iconStyleData.iconStyleData.pageCompIcon;
                break
            }
            case "3": {
                Icon = iconStyleData.iconStyleData.linkCompIcon;
                break
            }
            case "4": {
                Icon = iconStyleData.iconStyleData.videoCompIcon;
                break
            }
            case "5": {
                Icon = iconStyleData.iconStyleData.imgCompIcon;
                break
            }
            case "6": {
                Icon = iconStyleData.iconStyleData.img360CompIcon;
                break
            }
            default : {
                Icon = iconStyleData.iconStyleData.promoCompIcon;
                break
            }
        }
        return (
            <MenuItem value={frameType.value} key={frameType.value} sx={{
                padding: `6px 8px`,
            }}>
                <Box sx={{
                    display: `flex`,
                    alignItems: `center`,
                }}>
                    <Box sx={{width: `32px`, height: `32px`, marginRight: `4px`, borderRadius: "50%",
                        // backgroundColor: "#ffffff",
                        "& > svg > rect": {
                            fill: (flyerIconStyleType === 2 || flyerIconStyleType === 3) ? mainGuiColorForFlyer : undefined
                        }
                    }}>
                        <Icon style={{width: "100%", height: "100%"}}/>
                    </Box>
                    <Typography lineHeight={`25px`}>
                        {frameType.label}
                    </Typography>
                </Box>
            </MenuItem>

        )
    })

    return (
        <Box className={`${classes.framesRightPanel} ${classes.columnBox}`}>
            {
                selectedFramesData.length >= 1 ?
                    <>
                        <Box className={`${classes.columnBox} ${classes.framesRightPanelHeader}`}>
                            {/*<Box className={`${classes.frameRightPanelTitle} ${classes.rowBox}`}>*/}
                            {/*    <Typography>*/}
                            {/*        Fill in Frame's contents here:*/}
                            {/*    </Typography>*/}
                            {/*</Box>*/}
                            <Box className={`${classes.rowBox} ${classes.framesControlsWrapper}`}>
                                {
                                    selectedFramesData.length === 1 && selectedFramesData[0].fpsCode &&
                                    <Button
                                        disabled={ currentSelectedFrameIndex <= 0 || flippingFlyerState.loading}
                                        onClick={() => {
                                            onClickNextFrameBtn(false)
                                        }}
                                    ><ChevronLeft/></Button>
                                }
                                <Box sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexFlow: "row",
                                    columnGap: "8px"
                                }}>
                                    <Typography fontSize={`16px`} fontWeight={`600`}>
                                        {selectedFramesData.length === 1 ? (selectedFramesData && selectedFramesData[0].fpsPositionNo && selectedFramesData[0].fpsCode ? `Frame ${selectedFramesData[0].fpsPositionNo}` : `New Frame`) : `Number of Selected Frames ${selectedFramesData.length}`}
                                    </Typography>
                                    {
                                        promotionsItemsState.isQualified && selectedFramesData.length === 1 && selectedFramesData[0].fpsCode &&
                                        <Button className={classes.qualificationIconWrapper}
                                                disabled={isUserViewer || isUserEditor}
                                             sx={{
                                                 opacity: compareDefaultAndCurrentState() ? 0.5 : 1,
                                                 pointerEvents: compareDefaultAndCurrentState() ? "none" : "fill",
                                                 "&:disabled": {
                                                     opacity: "0.5"
                                                 }
                                             }}
                                             onClick={onChangeQualificationLVL}>
                                            {
                                                qualificationLvlForSelectedFrame === 0 &&
                                                <NotApprovePage title={`Frame Unqualified. Check Promos & Items`}/>
                                            }
                                            {
                                                qualificationLvlForSelectedFrame === 1 &&
                                                <ApprovePageForSystem title={`Frame Qualified. Click to Approve.`}/>
                                            }
                                            {
                                                qualificationLvlForSelectedFrame === 2 &&
                                                <ApprovePage title={`Frame Approved. Click to remove approval.`}/>
                                            }
                                        </Button>
                                    }
                                </Box>
                                {
                                    selectedFramesData.length === 1 && selectedFramesData[0].fpsCode &&
                                    <Button
                                        disabled={currentSelectedFrameIndex === totalSpotsOnPageNumber - 1 || currentSelectedFrameIndex === -1 || flippingFlyerState.loading}
                                        onClick={() => {
                                            onClickNextFrameBtn(true)
                                        }}
                                    ><ChevronRight/></Button>
                                }
                            </Box>
                            {
                                coordinatesAndSizesForSelectedFrame &&
                                <Grid
                                    container
                                >
                                    <Grid item xs={6}>
                                        <Typography fontSize={`12px`}>
                                            Top-left XY:
                                            ({coordinatesAndSizesForSelectedFrame.x}, {coordinatesAndSizesForSelectedFrame.y})
                                        </Typography>
                                    </Grid>
                                    <Grid>
                                        <Typography fontSize={`12px`}>
                                            Width, Height:
                                            ({coordinatesAndSizesForSelectedFrame.width}, {coordinatesAndSizesForSelectedFrame.height})
                                        </Typography>
                                    </Grid>
                                </Grid>

                            }
                        </Box>
                        <Box className={`${classes.columnBox} ${classes.framesRightPanelContent}`}>
                            <Box className={classes.settingBox}>
                                <Box className={classes.titleBox}>
                                    <Typography>
                                        Frame Type
                                    </Typography>
                                </Box>
                                <Box>
                                    <Select
                                        disabled={isUserViewer}
                                        displayEmpty
                                        value={valueForFramesType.value}
                                        onChange={onChangeFrameType}
                                        inputProps={{'aria-label': 'Without label'}}
                                        sx={{
                                            width: `100%`,
                                            // height: `38px`,
                                            border: `1px solid #888888`,
                                            '& legend': {display: 'none'},
                                            '& fieldset': {
                                                top: 0,
                                                border: `none`,
                                            },
                                            '& > .MuiSelect-select': {
                                                padding: `6px 8px`
                                            }
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    "& .MuiMenuItem-root.Mui-selected": {
                                                        backgroundColor: "#4E7FA7!important",
                                                        '& .MuiTypography-root': {
                                                            color: `#ffffff`,
                                                        }
                                                    },
                                                    "& .MuiMenuItem-root:hover": {
                                                        backgroundColor: "#7FA2BF",
                                                        '& .MuiTypography-root': {
                                                            color: `#ffffff`,
                                                        }
                                                    },
                                                    "& .MuiMenuItem-root.Mui-selected:hover": {
                                                        backgroundColor: "#014780!important",
                                                        '& .MuiTypography-root': {
                                                            color: `#ffffff`,
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        {frameTypeSelectOptions}
                                    </Select>
                                </Box>
                            </Box>
                            <Box className={classes.settingBox}>
                                <Box className={classes.titleBox}>
                                    <Typography>
                                        Icon’s Position in Frame
                                    </Typography>
                                </Box>
                                <Box>
                                    <Grid container columnSpacing={`10px`}>
                                        <Grid item xs={6}>
                                            <Paper
                                                className={`${classes.inputBaseWrapper} ${Number(currentFramesState.fpsIconXPct) >= 5 && Number(currentFramesState.fpsIconXPct) <= 95 ? '' : 'notValid'}`}
                                                // component="in"
                                            >
                                                <Typography
                                                    className={classes.inputBaseLeftRightText}
                                                    sx={{
                                                        width: `20%`,
                                                    }}
                                                >
                                                    X:
                                                </Typography>
                                                <InputBase
                                                    // disabled={true}
                                                    // placeholder={placeholderForTitle ? placeholderForTitle : ``}
                                                    // type={`number`}
                                                    disabled={isUserViewer}
                                                    name={`fpsIconXPct`}
                                                    value={currentFramesState.fpsIconXPct ? currentFramesState.fpsIconXPct : ``}
                                                    onChange={onChangeInput}
                                                    inputProps={{maxLength: 300}}
                                                    className={`${classes.inputStyles} ${classes.baseInput}`}
                                                />
                                                <Typography
                                                    sx={{
                                                        width: `12%`,
                                                        textAlign: `center`,
                                                        lineHeight: `15px`,
                                                        fontSize: `14px`,
                                                        color: `#A3A3A3`
                                                    }}
                                                >
                                                    %
                                                </Typography>
                                            </Paper>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Grid item xs>
                                                <Paper
                                                    className={`${classes.inputBaseWrapper} ${Number(currentFramesState.fpsIconYPct) >= 5 && Number(currentFramesState.fpsIconYPct) <= 95 ? '' : 'notValid'}`}
                                                    // component="form"
                                                >
                                                    <Typography
                                                        sx={{
                                                            width: `20%`,
                                                            textAlign: `center`,
                                                            lineHeight: `15px`,
                                                            fontSize: `14px`,
                                                            color: `#A3A3A3`
                                                        }}
                                                    >
                                                        Y:
                                                    </Typography>
                                                    <InputBase
                                                        disabled={isUserViewer}
                                                        // disabled={true}
                                                        // placeholder={placeholderForTitle ? placeholderForTitle : ``}
                                                        // type={`number`}
                                                        name={`fpsIconYPct`}
                                                        value={currentFramesState.fpsIconYPct ? currentFramesState.fpsIconYPct : ``}
                                                        onChange={onChangeInput}
                                                        inputProps={{maxLength: 300}}
                                                        className={`${classes.inputStyles} ${classes.baseInput}`}
                                                    />
                                                    <Typography
                                                        sx={{
                                                            width: `12%`,
                                                            textAlign: `center`,
                                                            lineHeight: `15px`,
                                                            fontSize: `14px`,
                                                            color: `#A3A3A3`
                                                        }}
                                                    >
                                                        %
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                            <Box className={classes.settingBox}>
                                <Box className={classes.titleBox}>
                                    <Typography>
                                        Frame Tooltip
                                    </Typography>
                                </Box>
                                <Box>
                                    <Input
                                        disableUnderline
                                        disabled={isUserViewer}
                                        className={`${classes.inputStyles}`}
                                        name={`fpsTooltip`}
                                        value={currentFramesState.fpsTooltip ? currentFramesState.fpsTooltip : ``}
                                        placeholder={placeholderForTitle ? placeholderForTitle : ``}
                                        onChange={onChangeInput}
                                        inputProps={{maxLength: 300}}
                                    />
                                </Box>
                            </Box>
                            {currentFramesState.fpsFrameType && currentFramesState.fpsFrameType !== 1 &&
                                <>
                                    <Box className={classes.settingBox}>
                                        <Box className={classes.titleBox}>
                                            <Typography>
                                                Desktop Frame Link
                                            </Typography>
                                            <EyeIcon
                                                data-tip
                                            />
                                            {
                                                isValid &&
                                                <ReactTooltip
                                                    arrowColor={`#00000080`}
                                                    afterShow={setDataForPreviewBasedOnFrameType}
                                                    afterHide={() => {
                                                        setDataForPreviewLink({
                                                            description: ``,
                                                            image: ``,
                                                            title: ``,
                                                            url: ``,
                                                            domain: ``,
                                                            frameType: valueForFramesType.value || "0"
                                                        });
                                                    }}
                                                    aria-haspopup='true'
                                                    // id={`props.flyerDto.flyCode`}
                                                    // offset={{'top': 10, 'left': 5}}
                                                    role='example'
                                                    delayShow={1000}
                                                    className={`${styles.previewLinkTooltip} tooltip_custom_white`}
                                                >
                                                    <PreviewUrlPopup previewUrlData={dataForPreviewLink}/>
                                                </ReactTooltip>
                                            }

                                        </Box>
                                        <Box>
                                            <Input
                                                disabled={isUserViewer}
                                                disableUnderline
                                                className={`${classes.inputStyles} ${!isValid ? 'notValid' : ''}`}
                                                name={`fpsFrameLink`}
                                                placeholder={placeholderForLink ? placeholderForLink : ``}
                                                value={currentFramesState.fpsFrameLink ? currentFramesState.fpsFrameLink : ``}
                                                onChange={onChangeInput}
                                                inputProps={{maxLength: 300}}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <>
                                                        </>

                                                    </InputAdornment>
                                                }
                                            />
                                        </Box>
                                    </Box>
                                </>
                            }

                            {
                                currentFramesState.fpsFrameType && currentFramesState.fpsFrameType !== 1 && currentFramesState.fpsFrameType !== 2 &&
                                <Box className={classes.settingBox}>
                                    <Box className={classes.titleBox}>
                                        <Typography>
                                            App Frame Link
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Input
                                            disabled={isUserViewer}
                                            disableUnderline
                                            className={`${classes.inputStyles} ${!isValidUrlApp ? 'notValid' : ''}`}
                                            name={`fpsFrameLinkApp`}
                                            placeholder={placeholderForAppLink ? placeholderForAppLink : ``}
                                            value={currentFramesState.fpsFrameLinkApp ? currentFramesState.fpsFrameLinkApp : ``}
                                            onChange={onChangeInput}
                                            inputProps={{maxLength: 300}}
                                        />
                                    </Box>
                                </Box>
                            }
                            <Box className={classes.settingBox}>
                                <Box className={classes.titleBox}>
                                    <Typography>
                                        ToC Title
                                    </Typography>
                                </Box>
                                <Box>
                                    <Input
                                        disabled={isUserViewer}
                                        disableUnderline
                                        className={`${classes.inputStyles}`}
                                        name={`fpsTocEntry`}
                                        value={currentFramesState.fpsTocEntry?.caption ? currentFramesState.fpsTocEntry.caption : ``}
                                        onChange={onChangeInput}
                                        inputProps={{maxLength: 300}}
                                    />
                                </Box>
                            </Box>
                        </Box>


                        <Box className={`${classes.rowBox} ${classes.framesRightPanelFooter}`}>
                            <Button onClick={onSaveFramesSetting} disabled={isDisabledSaveButton}>
                                <Typography color={`#ffffff`}>
                                    Save
                                </Typography>
                            </Button>
                        </Box>
                    </> :
                    <Box
                        className={classes.frameRightPanelTitle}
                        sx={{display: `flex`, height: `100%`, alignItems: `center`, justifyContent: `center`}}>
                        <Typography>
                            No Selected Frames
                        </Typography>
                    </Box>
            }
        </Box>
    )

}